/**
 * File gform.js.
 *
 * Gravity Forms theme customization.
 *
 * @package wildrivers
 */

const floatLabelInputsBound = new WeakSet();

/**
 * Bind float-label behavior for Gravity Forms.
 *
 * Runs on full document by default. After AJAX validation reloads, pass the
 * form wrapper `#gform_wrapper_{id}` so only that subtree is processed.
 *
 * @param {ParentNode} [root=document] Container to search within.
 * @return {void}
 */
export function gform( root = document ) {

	const forms = root.querySelectorAll(
		root === document ? '.gform_wrapper .float-labels' : '.float-labels'
	);

	forms.forEach( ( form ) => {

		const labels = form.querySelectorAll( '.gfield:not(.gform_validation_container):not(.hidden_label):not(:has(.ginput_complex)) > .gfield_label' );
		labels.forEach( ( label ) => {
			const field = label.parentElement;
			const input = field.querySelector( '.ginput_container input, .ginput_container textarea, .ginput_container select' );
			if ( ! input || floatLabelInputsBound.has( input ) ) {
				return;
			}
			floatLabelInputsBound.add( input );

			if ( '' !== input.value ) {
				field.classList.add( 'field-filled' );
			}
			input.addEventListener( 'focus', ( el ) => {
				if ( '' === el.target.value ) {
					field.classList.add( 'field-filled' );
				}
			} );
			input.addEventListener( 'blur', ( el ) => {
				if ( '' === el.target.value ) {
					field.classList.remove( 'field-filled' );
				}
			} );
		} );

		const complex_labels = form.querySelectorAll( '.ginput_complex label' );
		complex_labels.forEach( ( label ) => {
			const field = label.parentElement;
			const input = field.querySelector( 'input' );
			if ( ! input || floatLabelInputsBound.has( input ) ) {
				return;
			}
			floatLabelInputsBound.add( input );

			if ( '' !== input.value ) {
				field.classList.add( 'field-filled' );
			}
			input.addEventListener( 'focus', ( el ) => {
				if ( '' === el.target.value ) {
					field.classList.add( 'field-filled' );
				}
			} );
			input.addEventListener( 'blur', ( el ) => {
				if ( '' === el.target.value ) {
					field.classList.remove( 'field-filled' );
				}
			} );
		} );
	} );
}
